import m from "./index34.js";
import { resolveComponent as y, openBlock as n, createElementBlock as r, createVNode as p, normalizeClass as g, createSlots as c, withCtx as t, createElementVNode as e, toDisplayString as a, createCommentVNode as k, pushScopeId as f, popScopeId as u } from "vue";
import "./index35.js";
import h from "../../../../_virtual/index.js";
const d = (o) => (f("data-v-ee68952f"), o = o(), u(), o), v = {
  key: 0,
  class: "disclaimer-desktop"
}, b = /* @__PURE__ */ d(() => /* @__PURE__ */ e("span", null, "\u2009", -1)), D = ["innerHTML"], w = ["innerHTML"], P = /* @__PURE__ */ d(() => /* @__PURE__ */ e("span", null, "\u2009", -1)), C = /* @__PURE__ */ d(() => /* @__PURE__ */ e("br", null, null, -1)), T = { class: "disclaimer-button" }, L = { class: "disclaimer-button" }, H = {
  key: 1,
  class: "disclaimer-desktop disclaimer-text"
}, K = ["innerHTML"];
function $(o, i, E, B, S, M) {
  const l = y("i18n-t");
  return o.config.sitebrand === "LawDepot" || o.config.sitebrand === "Doculaw" ? (n(), r("div", v, [
    p(l, {
      keypath: o.getKeyPath("@ado/base-application.footer.use-of-site"),
      tag: "span",
      class: g(["disclaimer-text", { "simple-disclaimer": o.isSimpleStyle }]),
      scope: "global"
    }, c({
      tos: t(() => [
        e("button", {
          class: "disclaimer-button disclaimer-terms-of-use-link",
          onClick: i[0] || (i[0] = (...s) => o.showTermsOfUseDialog && o.showTermsOfUseDialog(...s))
        }, a(o.t(`${o.footerKey}.terms-of-use`)), 1)
      ]),
      privacyPolicy: t(() => [
        e("button", {
          class: "disclaimer-button disclaimer-privacy-policy-link",
          onClick: i[3] || (i[3] = (...s) => o.showPrivacyPolicyDialog && o.showPrivacyPolicyDialog(...s))
        }, a(o.t(`${o.footerKey}.privacy-policy`)), 1)
      ]),
      editorialPolicy: t(() => [
        e("button", {
          class: "disclaimer-button disclaimer-editorial-policy-link",
          onClick: i[4] || (i[4] = (...s) => o.showEditorialPolicyDialog && o.showEditorialPolicyDialog(...s))
        }, a(o.t(`${o.footerKey}.editorial-policy`)), 1)
      ]),
      _: 2
    }, [
      o.settings.showDisclaimerLink ? {
        name: "disclaimer",
        fn: t(() => [
          o.settings.showDisclaimerLink ? (n(), r("button", {
            key: 0,
            class: "disclaimer-button disclaimer-disclaimer-link",
            onClick: i[1] || (i[1] = (...s) => o.showDisclaimerDialog && o.showDisclaimerDialog(...s))
          }, a(o.t(`${o.footerKey}.disclaimer`)), 1)) : k("", !0)
        ]),
        key: "0"
      } : void 0,
      o.showCookiePolicyLink ? {
        name: "cookiePolicy",
        fn: t(() => [
          e("button", {
            class: "disclaimer-button disclaimer-cookie-policy-link",
            onClick: i[2] || (i[2] = (...s) => o.showCookiePolicyDialog && o.showCookiePolicyDialog(...s))
          }, a(o.t(o.footerKey + ".cookie-policy")) + ", ", 1)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["keypath", "class"]),
    b,
    p(l, {
      keypath: o.getKeyPath("@ado/base-application.footer.consent"),
      tag: "span",
      class: "disclaimer-text",
      scope: "global"
    }, {
      siteBrand: t(() => [
        e("span", {
          innerHTML: o.settings.brand
        }, null, 8, D)
      ]),
      copyRight: t(() => [
        e("span", { innerHTML: o.footerCopyrightText }, null, 8, w)
      ]),
      _: 1
    }, 8, ["keypath"]),
    P,
    C,
    p(l, {
      class: "disclaimer-text",
      keypath: o.getKeyPath("@ado/base-application.footer.recaptcha-google"),
      tag: "span",
      scope: "global"
    }, c({
      googlePrivacyPolicy: t(() => [
        e("a", {
          class: "disclaimer-button",
          href: "https://policies.google.com/privacy",
          target: "_blank",
          onClick: i[5] || (i[5] = (...s) => o.navigationEventBus.navigateToHref && o.navigationEventBus.navigateToHref(...s))
        }, [
          e("button", T, a(o.t(`${o.footerKey}.google-privacy-policy`)), 1)
        ])
      ]),
      _: 2
    }, [
      o.settings.showDisclaimerLink ? {
        name: "googleTos",
        fn: t(() => [
          e("a", {
            href: "https://policies.google.com/terms",
            target: "_blank",
            onClick: i[6] || (i[6] = (...s) => o.navigationEventBus.navigateToHref && o.navigationEventBus.navigateToHref(...s))
          }, [
            e("button", L, a(o.t(`${o.footerKey}.terms-of-service`)), 1)
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["keypath"])
  ])) : (n(), r("div", H, [
    e("span", { innerHTML: o.footerCopyrightText }, null, 8, K)
  ]));
}
const U = /* @__PURE__ */ h(m, [["render", $], ["__scopeId", "data-v-ee68952f"]]);
export {
  U as default
};
//# sourceMappingURL=index27.js.map
